export enum PermissionMutationType {
  SET_ROUTES = 'SET_ROUTES',
  SET_PERMISSIONS = 'SET_PERMISSIONS'
}
